import {Component, ViewChild} from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-datepicker',
  template: `
    <div class="form-group">
      <div class="input-group" #datetimeIconPosition>
        <div  (click)="handlePositionClick()" class="input-group-prepend" style="cursor: pointer" *ngIf="dtOptions.displayIcon && dtOptions.iconPosition == 'left'">
          <span class="input-group-text bg-transparent border-right-0">
            <i class="fa fa-calendar"></i>
          </span>
        </div>
        <owl-date-time [pickerType]="dtOptions.pickerType" #d></owl-date-time>
        <input class="form-control pl-2 border-left-0" [formControl]="formControl"
               [min]="dtOptions.min" [max]="dtOptions.max"
               [formlyAttributes]="field" [owlDateTimeTrigger]="d" [owlDateTime]="d" #datetimeInput>
        <div class="input-group-append cursor-pointer" *ngIf="dtOptions.displayIcon && dtOptions.iconPosition === 'right'" (click)="handlePositionClick()" #datetimeIconPosition>
          <span class="input-group-text">
            <i class="fa fa-calendar"></i>
          </span>
        </div>
      </div>
    </div>
  `,
})
export class DatepickerTypeComponent extends FieldType {
  field;
  // About options document here https://github.com/DanielYKPan/date-time-picker#readme
  dtOptions = {
    min: null,
    max: null,
    pickerType: 'both',
    displayIcon: true,
    iconPosition: 'right'
  };

  @ViewChild('datetimeIconPosition') datetimeIconPosition;
  @ViewChild('datetimeInput') datetimeInput;

  constructor(){
    super();
  }

  ngOnInit() {
    if (this.field.templateOptions.dtOptions) {
      Object.assign(this.dtOptions, this.field.templateOptions.dtOptions)
    }
  }

  handlePositionClick() {
    this.datetimeInput.nativeElement.click();
  }
}
